export default __webpack_public_path__ + "static/media/skelly_0003.cc01a3d3.png";